import React, { useEffect, useState } from 'react';
import './PageStyle.css';

function TermsConditionPage() {

  const [language, setLanguage] = useState('AR');
  const [isGradient, setIsGradient] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (!lang || (lang.toUpperCase() !== 'EN' && lang.toUpperCase() !== 'AR')) {
      return;
    }
    setLanguage(lang.toUpperCase());
    setIsGradient(lang.toUpperCase() === 'EN' ? true : false);
  }, []);

  const handleLanguage = (event) => {
    const selectedLang = event.target.textContent.trim();
    setLanguage(selectedLang === 'English' ? 'EN' : 'AR');
    setIsGradient(selectedLang === 'English' ? true : false);
  };

  const gradientStyle = {
    background: isGradient
      ? 'linear-gradient(to right, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)'
      : 'linear-gradient(to left, rgba(103, 193, 98, 0.4) 50%, rgba(103, 193, 98, 1) 50%)',
  };

  return (
    <div className="Aa000">
      <div className='container'>
        <div className='header'>
          <div className='header-left'>
            <div className="language" style={gradientStyle} onClick={handleLanguage}>
              <div className='language-left'>
                <span>عربي</span>
              </div>
              <div className='language-middle'>
                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeWidth="2" d="M12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 Z M12,23 C15,23 16,18 16,12 C16,6 15,1 12,1 C9,1 8,6 8,12 C8,18 9,23 12,23 Z M2,16 L22,16 M2,8 L22,8"></path></svg>
              </div>
              <div className='language-right'>
                <span>English</span>
              </div>
            </div>
          </div>
          <div className='header-right'>
            <div className='logo'><img alt='CoreFlex' src='%PUBLIC_URL%/../../logo.png' /></div>
          </div>
        </div>
        <div className='form-content'>
          <div className='title'>
            <h4 id='headup-title'>{language === 'EN' ? 'Start working out on your mobile' : 'ابدأ في ممارسة التمارين الرياضية على هاتفك المحمول'}</h4>
          </div>
          <div className='form-content-top'>
            <div className='logo'><img alt='CoreFlex' src='%PUBLIC_URL%/../../banner_new.png' /></div>
          </div>
          <div id='terms' className='form-content-middle'>
            {language === 'AR' ?
              <ul className='arabic'>
                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  المقدمة<br></br><br></br>
                  <li>مرحبًا بكم في Coreflex! تحكم هذه الشروط والأحكام ("الشروط") استخدامكم لتطبيق اللياقة البدنية Coreflex ("الخدمة"). باستخدامكم للخدمة أو الاشتراك فيها، فإنكم توافقون على هذه الشروط. إذا كنتم لا توافقون عليها، يرجى الامتناع عن استخدام الخدمة.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  تفاصيل الاشتراك<br></br><br></br>
                  <li><b>مقدم الخدمة</b>: يتم تشغيل خدمة Coreflex بواسطة <b>شركة الأفق لتقنية المعلومات - منطقة حرة ذ.م.م</b>، وهي شركة قائمة بموجب قوانين دولة الإمارات العربية المتحدة، وعنوانها المسجل في مبنى A1، مدينة دبي الرقمية، واحة دبي للسيليكون، دبي، الإمارات العربية المتحدة.</li>
                  <li><b>رسوم الاشتراك</b>: تبلغ رسوم الاشتراك اليومي <b>240 دينار عراقي</b>.</li>
                  <li><b>التجديد التلقائي</b>: يتم تجديد الاشتراك تلقائيًا يوميًا حتى يتم إلغاؤه.</li>
                  <li><b>التجربة المجانية</b>: يحصل المستخدمون الجدد على <b>يوم مجاني للتجربة</b>. بعد انتهاء التجربة، سيتم تطبيق رسوم الاشتراك اليومي ما لم يتم إلغاء الاشتراك.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  كيفية إلغاء الاشتراك<br></br><br></br>
                  <li>يمكن للمستخدمين إلغاء الاشتراك في الخدمة في أي وقت عن طريق إرسال الرمز <b>019</b> إلى الرقم <b>4086</b>. سيؤدي إلغاء الاشتراك إلى إيقاف أي رسوم إضافية.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  مسؤوليات المستخدم<br></br><br></br>
                  <li>التأكد من توفر اتصال بالإنترنت في جهازكم وأنه يلبي الحد الأدنى من المتطلبات التقنية لتطبيق Coreflex.</li>
                  <li>استخدام الخدمة فقط لأغراض شخصية وغير تجارية.</li>
                  <li>عدم مشاركة بيانات الحساب أو السماح للآخرين بالوصول إلى الخدمة باستخدام اشتراككم.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  الدعم الفني<br></br><br></br>
                  <li>للدعم أو الاستفسارات، يُرجى التواصل معنا عبر البريد الإلكتروني: <b>support@coreflex.fun</b>.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  سياسة الإلغاء والاسترداد<br></br><br></br>
                  <li>يمكنكم إلغاء الاشتراك في أي وقت باتباع عملية الإلغاء الموضحة أعلاه.</li>
                  <li>رسوم الاشتراك التي تم دفعها غير قابلة للاسترداد، إلا إذا نصت القوانين المعمول بها على خلاف ذلك.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  توفر الخدمة<br></br><br></br>
                  <li>نسعى لتوفير الخدمة على مدار الساعة طوال أيام الأسبوع. ومع ذلك، لا نضمن الوصول المستمر وغير المنقطع للخدمة، ولسنا مسؤولين عن أي انقطاعات ناتجة عن أعمال الصيانة أو مشكلات تقنية أو عوامل خارجة عن إرادتنا.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  التغييرات على الخدمة<br></br><br></br>
                  <li>نحتفظ بالحق في تعديل الخدمة أو هذه الشروط أو إنهائها في أي وقت. سيتم إخطار المستخدمين بالتغييرات المهمة، ويُعتبر استمراركم في استخدام الخدمة قبولاً لهذه التغييرات.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  تحديد المسؤولية<br></br><br></br>
                  <li>لا تتحمل شركة الأفق لتقنية المعلومات - منطقة حرة ذ.م.م المسؤولية عن أي أضرار غير مباشرة أو عرضية أو تبعية ناتجة عن استخدام الخدمة أو عدم القدرة على استخدامها.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  القانون الحاكم<br></br><br></br>
                  <li>تخضع هذه الشروط لقوانين دولة الإمارات العربية المتحدة. يتم تسوية أي نزاعات تتعلق بالخدمة أمام المحاكم المختصة في دبي.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  أحكام عامة<br></br><br></br>
                  <li>تمثل هذه الشروط الاتفاق الكامل بين المستخدم وشركة الأفق لتقنية المعلومات - منطقة حرة ذ.م.م.</li>
                  <li>إذا تبين أن أي بند من هذه الشروط غير صالح أو غير قابل للتنفيذ، فستظل البنود الأخرى سارية المفعول.</li>
                </ul>
              </ul>
              :
              <ul className='english'>
                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  Introduction<br></br><br></br>
                  <li>Welcome to Coreflex! These Terms and Conditions ("T&Cs") govern the use of our fitness workout application ("Service"). By subscribing to or using Coreflex, you agree to these T&Cs. If you do not agree, please refrain from using our Service.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  Subscription Details<br></br><br></br>
                  <li><b>Service Provider</b>: Coreflex is operated by <b>ALHORIZON IT NETWORK SERVICES - FZCO</b>, a company established under the laws of the United Arab Emirates, with its registered address at Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai, UAE.</li>
                  <li><b>Subscription Fee</b>: The daily subscription fee is <b>240 IQD</b>.</li>
                  <li><b>Auto-Renewal</b>: The subscription is automatically renewed daily until canceled.</li>
                  <li><b>Free Trial</b>: New users are entitled to a <b>1-day free trial</b>. After the trial, the daily subscription fee will apply unless canceled.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  How to Unsubscribe<br></br><br></br>
                  <li>Users may unsubscribe from the Service at any time by sending the code <b>019</b> to <b>4086</b>. Unsubscribing will stop further charges from being applied.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  User Responsibilities<br></br><br></br>
                  <li>Ensure your device has internet access and meets the minimum technical requirements for the Coreflex application.</li>
                  <li>Use the Service only for personal, non-commercial purposes.</li>
                  <li>Do not share your account credentials or allow others to access the Service using your subscription.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  Support<br></br><br></br>
                  <li>For support or inquiries, please contact us via email at <b>support@coreflex.fun</b>.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  Cancellation and Refund Policy<br></br><br></br>
                  <li>You may cancel your subscription at any time by following the unsubscribe process described above.</li>
                  <li>Subscription fees already charged are non-refundable, except as required by applicable laws.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  Service Availability<br></br><br></br>
                  <li>We strive to keep the Service available 24/7. However, we do not guarantee uninterrupted access and are not responsible for downtime caused by maintenance, technical issues, or other factors beyond our control.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  Changes to the Service<br></br><br></br>
                  <li>We reserve the right to modify or discontinue the Service or these T&Cs at any time. Users will be notified of significant changes, and continued use of the Service constitutes acceptance of such changes.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  Limitation of Liability<br></br><br></br>
                  <li>ALHORIZON IT NETWORK SERVICES - FZCO is not liable for any indirect, incidental, or consequential damages arising from the use or inability to use the Service.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  Governing Law<br></br><br></br>
                  <li>These T&Cs are governed by the laws of the United Arab Emirates. Any disputes arising from the Service will be resolved in the competent courts of Dubai.</li>
                </ul>

                <br></br><br></br><br></br>

                <ul style={{ listStyleType: 'none', textAlign: 'center' }}>
                  Miscellaneous<br></br><br></br>
                  <li>These T&Cs constitute the entire agreement between the user and ALHORIZON IT NETWORK SERVICES - FZCO.</li>
                  <li>If any provision of these T&Cs is found to be invalid or unenforceable, the remaining provisions will remain in effect.</li>
                </ul>
              </ul>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsConditionPage;